import { gql } from "@apollo/client";

export const GET_CONSULTA_CIERRE_DIFERENCIA = gql`
query consultaCierreDiferencia($mes: Int!, $anio: Int!) {
    consultaCierreDiferencia(mes: $mes, anio: $anio) { 
       	valorEsperado{
            idConexion
            idMinuta
            cod_Paciente
            paciente
            idEvaluacion
            precioDiario
            idCliente
            cliente
            moduloTipo
            delegacion
            usuario
            fechaConexion
            fechaAlta
            accion
        }
    }
}`;